<template>
    <v-autocomplete
        v-if="autocomplete"
        ref="autocomplete"
        v-bind="mergedAttrs"
        v-on="$listeners"
        :menu-props="mergedMenuProps"
        :search-input.sync="searchInput"
    >
        <template v-if="showSelectAll && isMultiple" v-slot:prepend-item>
            <v-list-item
                ripple
                @mousedown.prevent
                @click="toggleSelectAll"
            >
                <v-list-item-action>
                    <v-icon>
                        {{
                            isAllSelected
                                ? "mdi-close-box"
                                : internalValue.length === 0
                                ? "mdi-checkbox-blank-outline"
                                : "mdi-minus-box"
                        }}
                    </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{
                            isAllSelected ? "Desmarcar" : "Selecionar"
                        }}
                        todos
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>
        <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope"></slot>
        </template>
        <template v-if="isMultiple && !hasCustomSelectionSlot" v-slot:selection="{ item, index }">
            <div
                v-if="internalValue.length === 1 && index === 0"
                class="autocomplete-selecao"
            >
                {{ item.text }}
            </div>
            <span
                v-if="internalValue.length > 1 && index === 0"
                class="grey--text caption mr-1"
            >
                {{ internalValue.length }} selecionados
            </span>
        </template>
    </v-autocomplete>
    <v-select
        v-else
        v-bind="mergedAttrs"
        v-on="$listeners"
        :menu-props="mergedMenuProps"
    >
        <template v-if="showSelectAll && isMultiple" v-slot:prepend-item>
            <v-list-item
                ripple
                @mousedown.prevent
                @click="toggleSelectAll"
            >
                <v-list-item-action>
                    <v-icon>
                        {{
                            isAllSelected
                                ? "mdi-close-box"
                                : internalValue.length === 0
                                ? "mdi-checkbox-blank-outline"
                                : "mdi-minus-box"
                        }}
                    </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{
                            isAllSelected ? "Desmarcar" : "Selecionar"
                        }}
                        todos
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>
        <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope"></slot>
        </template>
        <template v-if="isMultiple && !hasCustomSelectionSlot" v-slot:selection="{ item, index }">
            <div
                v-if="internalValue.length === 1 && index === 0"
                class="autocomplete-selecao"
            >
                {{ item.text }}
            </div>
            <span
                v-if="internalValue.length > 1 && index === 0"
                class="grey--text caption mr-1"
            >
                {{ internalValue.length }} selecionados
            </span>
        </template>
    </v-select>
</template>

<script>
export default {
    name: "SelectInput",
    props: {
        autocomplete: {
            type: Boolean,
            default: true,
        },
        showSelectAll: {
            type: Boolean,
            default: false,
        },
        value: {
            default: null,
        },
        items: {
            type: Array,
            default: () => [],
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        menuProps: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            searchInput: "",
            defaultMenuProps: {
                // maxHeight: 200,
                'offset-overflow': false,

                top:false,
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
                zIndex: 100,
            },
        };
    },
    computed: {
        mergedMenuProps() {
            return {
                ...this.defaultMenuProps,
                ...this.menuProps,
            };
        },
        mergedAttrs() {
            // Remove props que já foram definidas explicitamente no componente
            const { 
                autocomplete, 
                showSelectAll, 
                menuProps, 
                value, 
                items, 
                multiple,
                ...restAttrs 
            } = this.$attrs;
            return {
                ...restAttrs,
                value: this.value,
                items: this.items,
                multiple: this.multiple,
            };
        },
        isMultiple() {
            return this.multiple === true;
        },
        internalValue() {
            if (!this.isMultiple) {
                return this.value ? [this.value] : [];
            }
            return Array.isArray(this.value) ? this.value : [];
        },
        availableItems() {
            if (!this.items || !Array.isArray(this.items)) {
                return [];
            }
            return this.items.filter((item) => {
                // Ignora itens que são objetos com propriedade disabled
                if (typeof item === "object" && item.disabled) {
                    return false;
                }
                return true;
            });
        },
        itemValues() {
            return this.availableItems.map((item) => {
                if (typeof item === "object" && item.value !== undefined) {
                    return item.value;
                }
                return item;
            });
        },
        filteredItems() {
            if (!this.searchInput || this.searchInput.trim() === "") {
                return this.availableItems;
            }
            const search = this.searchInput.toLowerCase().trim();
            return this.availableItems.filter((item) => {
                const text = typeof item === "object" ? (item.text || item.value || "") : item;
                return String(text).toLowerCase().includes(search);
            });
        },
        filteredItemValues() {
            return this.filteredItems.map((item) => {
                if (typeof item === "object" && item.value !== undefined) {
                    return item.value;
                }
                return item;
            });
        },
        isAllSelected() {
            if (!this.isMultiple || this.filteredItems.length === 0) {
                return false;
            }
            return (
                this.filteredItemValues.length > 0 &&
                this.filteredItemValues.every((val) => this.internalValue.includes(val))
            );
        },
        hasCustomSelectionSlot() {
            return !!this.$scopedSlots.selection;
        },
    },
    methods: {
        toggleSelectAll() {
            if (!this.isMultiple) {
                return;
            }

            if (this.isAllSelected) {
                // Desmarcar todos
                this.$emit("input", []);
            } else {
                // Selecionar apenas os itens filtrados (limpa seleções anteriores)
                this.$emit("input", [...this.filteredItemValues]);
            }
        },
    },
};
</script>

<style scoped></style>

